export const REFERENCE_GRAPH_BACKGROUND = [
    {
        name: 'Gray',
        gradientColors: ['#FFFFFF', '#B0B0B0', '#616161'],
        lineColor: '#606976',
    },
    {
        name: 'Green',
        gradientColors: ['#FFFFFF', '#8FF6BF', '#20D373'],
        lineColor: '#20D373',
    },
    {
        name: 'Red',
        gradientColors: ['#FFFFFF', '#EE3059'],
        lineColor: '#EE3059',
    },
];

export const HIGHLIGHT_TEXT_COLOR_LIST = [
    {
        ModuleName: 'SummaryModule',
        ColorList: [
            {
                name: '향상',
                color: '#439C62',
                backgroundColor: '#E6F8EC',
            },
            {
                name: '양호',
                color: '#439C62',
                backgroundColor: '#E6F8EC',
            },
            {
                name: '유지',
                color: '#439C62',
                backgroundColor: '#E6F8EC',
            },
            {
                name: '정체',
                color: '#CE5C5B',
                backgroundColor: '#FFEDF0',
            },
            {
                name: '주의',
                color: '#CE5C5B',
                backgroundColor: '#FFEDF0',
            },
            {
                name: '악화',
                color: '#CE5C5B',
                backgroundColor: '#FFEDF0',
            },
        ],
    },

    {
        ModuleName: 'CommentModule',
        ColorList: [
            {
                name: '체중',
                color: '#4682B4',
            },
            {
                name: '몸무게',
                color: '#4682B4',
            },
            {
                name: '체지방률',
                color: '#AF9481',
            },
            {
                name: '체지방량',
                color: '#CD9F64',
            },
            {
                name: '골격근량',
                color: '#B57170',
            },
        ],
    },
    {
        ModuleName: 'ReferenceModule',
        ColorList: [
            {
                name: '체중',
                color: '#4682B4',
            },
            {
                name: '몸무게',
                color: '#4682B4',
            },
            {
                name: '체지방률',
                color: '#AF9481',
            },
            {
                name: '체지방량',
                color: '#CD9F64',
            },
            {
                name: '골격근량',
                color: '#B57170',
            },
        ],
    },
    {
        ModuleName: 'VarianceModule',
        ColorList: [
            {
                name: '체중',
                color: '#4682B4',
            },
            {
                name: '몸무게',
                color: '#4682B4',
            },
            {
                name: '체지방률',
                color: '#AF9481',
            },
            {
                name: '체지방량',
                color: '#CD9F64',
            },
            {
                name: '골격근량',
                color: '#B57170',
            },
        ],
    },
    {
        ModuleName: 'EndingModule',
        ColorList: [
            {
                name: '체중',
                color: '#4682B4',
            },
            {
                name: '몸무게',
                color: '#4682B4',
            },
            {
                name: '체지방률',
                color: '#AF9481',
            },
            {
                name: '체지방량',
                color: '#CD9F64',
            },
            {
                name: '골격근량',
                color: '#B57170',
            },
        ],
    },
];
